<template>
  <div class="analytics">
    <div class="row">
      <perfect-scrollbar class="col-md-9">
        <div class="row">
          <div class="col-lg-12">
            <div class="shadow p-3 mb-3 bg-white rounded">
              <p class="font-weight-bold">Views</p>
              <Chart01 />
              <div class="d-flex filter-select form-inline">
                <select class="form-control ml-auto mr-2">
                  <option value="">All Portals</option>
                </select>
                <select class="form-control mr-2">
                  <option value="">All listings</option>
                </select>
                <select class="form-control mr-2">
                  <option value="">Last 14 days</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="shadow p-3 mb-3 bg-white rounded">
              <p class="font-weight-bold">Mentions by country</p>
              <div class="row">
                <div class="col-lg-8">
                  <Chart02 />
                  <div class="d-flex filter-select form-inline">
                    <select class="form-control ml-auto">
                      <option value="">All Channels</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4">
                  <Chart04 />
                  <div class="d-flex filter-select form-inline">
                    <select class="form-control ml-auto mr-2">
                      <option value="">All Tags</option>
                    </select>
                    <select class="form-control mr-2">
                      <option value="">Last 7 days</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="shadow p-3 mb-3 bg-white rounded">
              <p class="font-weight-bold">Visits by time of day</p>
              <Chart03 />
              <div class="d-flex filter-select form-inline">
                <select class="form-control ml-auto mr-2">
                  <option value="">All Channels</option>
                </select>
                <select class="form-control mr-2">
                  <option value="">All Tags</option>
                </select>
                <select class="form-control mr-2">
                  <option value="">Last 7 days</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
      <perfect-scrollbar class="col-md-3">
        <FilterList>
          <template v-slot:header>Report Options</template>
          <template v-slot:btn>
            <div class="mb-2">
          <button class="btn btn-secondary btn-block pa-1 mr-2">
            CREATE REPORT
          </button>
        </div>
          </template>
          <template v-slot:headerfilter>Filter Result</template>
          <template v-slot:filter>
            <form action="">
          <div class="form-group">
            <select class="form-control">
              <option value="">All Channels</option>
            </select>
          </div>
          <div class="form-group">
            <select class="form-control">
              <option value="">Last 14 days</option>
            </select>
          </div>
          <div class="form-group">
            <vue-tags-input
              v-model="tag"
              :tags="tags"
              placeholder="All Listing"
              @tags-changed="(newTags) => (tags = newTags)"
            />
          </div>
          <div class="form-group row align-items-center">
            <div class="col-lg-4 text-center">Start date</div>
            <div class="col-lg-8">
              <input type="date" class="form-control" />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-lg-4 text-center">End date</div>
            <div class="col-lg-8">
              <input type="date" class="form-control" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <button class="btn btn-apply btn-block py-1" @click="onSearch">
                <span></span>
                <span>APPLY</span>
                <i class="fas fa-check"></i>
              </button>
            </div>
            <div class="col-md-6">
              <button class="btn btn-reset btn-block py-1" @click="onReset">
                <span></span>
                <span>RESET FILTERS</span>
                <i class="fas fa-redo"></i>
              </button>
            </div>
          </div>
        </form>
          </template>
        </FilterList>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import FilterResult from "@/views/Analytics/components/FilterResult.vue";
import Chart01 from "@/views/Analytics/components/Chart01.vue";
import Chart02 from "@/views/Analytics/components/Chart02.vue";
import Chart03 from "@/views/Analytics/components/Chart03.vue";
import Chart04 from "@/views/Analytics/components/Chart04.vue";
import FilterList from "@/components/Filter";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "analytics",
  components: {
    FilterResult,
    Chart01,
    Chart02,
    Chart03,
    Chart04,
    FilterList,
    VueTagsInput,
  },
  data() {
    return {
      search: "",
      types: [],
      sort: "CREATED_AT",
      tag: '',
      tags: [],
    };
  },
  methods: {
    onAdd(type) {
      this.$emit("onAdd", type);
    },
    onClickChangeStatus(status) {
      this.$emit("onClickChangeStatus", status);
    },
    onSearch() {
      const data = {
        search: this.search,
        types: this.types,
        sort: this.sort,
      };
      this.$emit("search", data);
    },
    onReset() {
      this.search = "";
      this.types = [];
      this.btn.experience = false;
      this.btn.tour = false;
      this.btn.event = false;
      this.btn.story = false;
    }
  },
};
</script>

<style lang="scss">
.analytics {
  .ps {
    height: 85vh;
  }
  .filter-select {
    select {
      &.form-control {
        cursor: pointer;
        border: 0;
        border-radius: 0;
        background-image: url("../../assets/images/arrow-down.png");
        background-repeat: no-repeat, repeat;
        background-position: right 0 top 50%, 0 0;
        padding-right: 20px;
      }
    }
  }
}
</style>